import React from 'react';
const IconFormAddSquareOutlined = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 17H13V13H17V11H13V7H11V11H7V13H11V17Z" fill="#2D2E2E"/>
<path d="M3 3V21H21V3H3ZM19 19H5V5H19V19Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFormAddSquareOutlined;